'use client'

import { Dog, PawPrint } from 'lucide-react'
import { cn } from '@/lib/utils'

type MarketingDogIconProps = {
  className?: string
  'aria-hidden'?: boolean
}

/**
 * Two mirrored dog silhouettes (Lucide Dog) — playdates / dog-to-dog connection.
 * Sized via parent `className` (e.g. h-4 w-4 / h-6 w-6) like other marketing pills.
 */
export function MarketingPlayConnectionsIcon({
  className,
  'aria-hidden': ariaHidden = true,
}: MarketingDogIconProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center gap-px',
        className
      )}
      aria-hidden={ariaHidden}
    >
      <Dog className="h-[52%] w-[52%] min-h-[10px] min-w-[10px] shrink-0" strokeWidth={2.25} />
      <Dog
        className="h-[52%] w-[52%] min-h-[10px] min-w-[10px] shrink-0 scale-x-[-1]"
        strokeWidth={2.25}
      />
    </span>
  )
}

/**
 * Staggered paw prints — walking / surfaces (replaces human footprint metaphor).
 */
export function MarketingPawWalkIcon({
  className,
  'aria-hidden': ariaHidden = true,
}: MarketingDogIconProps) {
  return (
    <span
      className={cn(
        'inline-flex items-end justify-center gap-0.5',
        className
      )}
      aria-hidden={ariaHidden}
    >
      <PawPrint
        className="h-[48%] w-[48%] min-h-[9px] min-w-[9px] shrink-0 -rotate-[8deg] opacity-95"
        strokeWidth={2.25}
      />
      <PawPrint
        className="h-[54%] w-[54%] min-h-[10px] min-w-[10px] shrink-0 translate-y-px rotate-[14deg]"
        strokeWidth={2.25}
      />
    </span>
  )
}
